import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';
import { Icons } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

const ICON_BADGE_SIZE = 48;

export const PricingFilterSearchEmptyState: React.FC = () => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      description={i18n.t('pricing.filters.search.empty.description')}
      iconElement={
        <View style={styles.iconBadge}>
          <Icons.Search color={theme.sk.color.icon.tertiary} size="$20" />
        </View>
      }
      title={i18n.t('pricing.filters.search.empty.title')}
    />
  );
};

const useStyles = createStyles((theme) => ({
  iconBadge: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: theme.sk.radii.radiusLarge,
    height: ICON_BADGE_SIZE,
    justifyContent: 'center',
    width: ICON_BADGE_SIZE,
  },
}));
